import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { storage } from 'src/utilities/Storage';

export const trackTapHomeMenu = () => {
  AnalyticsManager.instance().track(AnalyticsEvent.tap_home_menu, {
    from: 'others',
  });
};

export const trackClickNotificationSidebar = () => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_notification_sidebar, {
    language: storage.get('lang') ?? 'id',
  });
};

export const trackTapInvoiceButton = () => {
  AnalyticsManager.instance().track(
    AnalyticsEvent.click_sidebar_account_receivable_create_invoice,
    {
      username: storage.get('auth').user.username,
    },
  );
};

export const trackTapCustomerManagementButton = () => {
  AnalyticsManager.instance().track(
    AnalyticsEvent.click_sidebar_account_receivable_customer_management,
    {
      username: storage.get('auth').user.username,
    },
  );
};

export const trackTapInvoiceListButton = () => {
  AnalyticsManager.instance().track(
    AnalyticsEvent.click_sidebar_account_payable_invoice,
    {
      username: storage.get('auth').user.username,
    },
  );
};

export const trackTapInvoiceTransactionButton = () => {
  AnalyticsManager.instance().track(
    AnalyticsEvent.click_sidebar_account_payable_transaction,
    {
      username: storage.get('auth').user.username,
    },
  );
};

export const trackTapVendorManagementButton = () => {
  AnalyticsManager.instance().track(
    AnalyticsEvent.click_sidebar_account_payable_vendor_management,
    {
      username: storage.get('auth').user.username,
    },
  );
};

export const clickNotificationButton = () => {
  AnalyticsManager.instance().track(
    AnalyticsEvent.click_dashboard_notification,
    {
      language: storage.get('lang') ?? 'id',
    },
  );
};
